import React from "react";

function About() {
  return (
    <div className="about-head">
      <h3>Electric motorized bicycles and scooters</h3>
      <p>
        We happily service all electric motorized bicycles sold through our
        shop. Electric bicycles and scooters not sold through are shop are
        serviced at our discretion. We always do our best to help our electric
        motorized customers in any way that we can, but we cannot offer service
        on electric batteries and motors not sold through our shop. We will not,
        under any circumstances, service gasoline powered moving objects of any
        kind.{" "}
      </p>
    </div>
  );
}

export default About;
